/* Marketfit · Regalos por umbral (Impulse) */
if (!customElements.get('mf-gift-tiers')) {
  customElements.define('mf-gift-tiers', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mf-tiers__track');
      this.note = this.querySelector('.mf-tiers__note');
      this.tiers = (this.dataset.tiers || '').split(',').map(function (s) { var p = s.split(':'); return { min: parseInt(p[0], 10), label: (p[1] || '').trim() }; }).filter(function (t) { return t.min > 0; });
      this.render(parseInt(this.dataset.total || '0', 10));
      this._h = this.onCartChange.bind(this);
      document.addEventListener('afterCartChanged', this._h);
      document.addEventListener('afterUpdateQuantity', this._h);
    }
    disconnectedCallback() {
      document.removeEventListener('afterCartChanged', this._h);
      document.removeEventListener('afterUpdateQuantity', this._h);
    }
    onCartChange() {
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) { this.render(c.total_price); }.bind(this)).catch(function () {});
    }
    money(cents) {
      if (window.Shopify && typeof window.Shopify.showPrice === 'function') return window.Shopify.showPrice(cents);
      return 'S/ ' + (cents / 100).toLocaleString('es-PE', { minimumFractionDigits: 2 });
    }
    render(total) {
      if (!this.track) return;
      var self = this;
      this.track.innerHTML = this.tiers.map(function (t) {
        var on = total >= t.min;
        return '<li class="mf-tiers__step' + (on ? ' is-on' : '') + '"><span class="mf-tiers__dot">' + (on ? '✓' : '') + '</span><span class="mf-tiers__label">' + self.money(t.min).replace(/[.,]00.*$/, '') + '<br>' + t.label + '</span></li>';
      }).join('');
      var next = this.tiers.find(function (t) { return total < t.min; });
      if (this.note) this.note.innerHTML = next ? 'Agrega <b>' + this.money(next.min - total) + '</b> más y desbloqueas «' + next.label + '».' : 'Tienes todos los regalos desbloqueados.';
    }
  });
}
